export default "__VITE_ASSET__OYlFzf8b__"